import {
  getMemberPrivacySettings as publicGetMemberPrivacySettings,
  setMemberPrivacySettings as publicSetMemberPrivacySettings,
} from './members-v1-member-privacy-settings-member-privacy-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getMemberPrivacySettings: MaybeContext<
  BuildRESTFunction<typeof publicGetMemberPrivacySettings> &
    typeof publicGetMemberPrivacySettings
> = /*#__PURE__*/ createRESTModule(publicGetMemberPrivacySettings);
export const setMemberPrivacySettings: MaybeContext<
  BuildRESTFunction<typeof publicSetMemberPrivacySettings> &
    typeof publicSetMemberPrivacySettings
> = /*#__PURE__*/ createRESTModule(publicSetMemberPrivacySettings);

export {
  Visibility,
  Candidates,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './members-v1-member-privacy-settings-member-privacy-settings.universal.js';
export {
  MemberPrivacySettings,
  GetMemberPrivacySettingsRequest,
  GetMemberPrivacySettingsResponse,
  BulkGetMemberPrivacySettingsRequest,
  BulkGetMemberPrivacySettingsResponse,
  SiteMemberInstanceMemberPrivacySettings,
  SetMemberPrivacySettingsRequest,
  SetMemberPrivacySettingsResponse,
  InvalidRevisionPayload,
  InvalidSettingsPayload,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
} from './members-v1-member-privacy-settings-member-privacy-settings.universal.js';
export {
  VisibilityWithLiterals,
  CandidatesWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  SetMemberPrivacySettingsApplicationErrors,
} from './members-v1-member-privacy-settings-member-privacy-settings.universal.js';
